import { render } from "./ChatRoomWindowContainer.vue?vue&type=template&id=83d3d948&scoped=true"
import script from "./ChatRoomWindowContainer.vue?vue&type=script&lang=js"
export * from "./ChatRoomWindowContainer.vue?vue&type=script&lang=js"

import "./ChatRoomWindowContainer.vue?vue&type=style&index=0&id=83d3d948&scoped=true&lang=scss"

import exportComponent from "/var/www/blocks/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83d3d948"]])

export default __exports__